import { StrictMode, useEffect, useRef, useState } from "react";
import { createRoot } from "react-dom/client";

const APP_NAME = "Cozy Hearth";

function App() {
  const [isPlaying, setIsPlaying] = useState(false);
  const audioRef = useRef<HTMLAudioElement | null>(null);

  useEffect(() => {
    // Use a high-quality crackling fireplace sound from a public CDN
    audioRef.current = new Audio("https://www.soundjay.com/nature/sounds/fire-crackling-01.mp3");
    audioRef.current.loop = true;

    return () => {
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current = null;
      }
    };
  }, []);

  const togglePlay = () => {
    if (!audioRef.current) return;
    if (isPlaying) {
      audioRef.current.pause();
    } else {
      audioRef.current.play().catch((e) => console.error("Audio play failed:", e));
    }
    setIsPlaying(!isPlaying);
  };

  return (
    <div
      style={{
        fontFamily: '"Segoe UI", Roboto, Helvetica, Arial, sans-serif',
        backgroundColor: "#1a0f0a",
        color: "#f5ebd7",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        transition: "background-color 2s ease",
        backgroundImage: isPlaying
          ? "radial-gradient(circle at center, #4a2c1a 0%, #1a0f0a 100%)"
          : "none",
      }}
    >
      <div
        style={{
          textAlign: "center",
          padding: "3rem",
          borderRadius: "2rem",
          border: "2px solid #5d3a25",
          backgroundColor: "rgba(40, 20, 10, 0.8)",
          boxShadow: isPlaying ? "0 0 50px #ff4500" : "0 0 20px rgba(0,0,0,0.5)",
          transition: "all 1s ease",
        }}
      >
        <h1 style={{ fontSize: "3rem", marginBottom: "1rem", color: "#ff8c00" }}>{APP_NAME}</h1>
        <p style={{ fontSize: "1.2rem", marginBottom: "2rem", opacity: 0.8 }}>
          {isPlaying ? "Enjoy the warmth and the crackle..." : "Quiet as a winter's night."}
        </p>

        <button
          onClick={togglePlay}
          style={{
            padding: "1rem 2rem",
            fontSize: "1.5rem",
            cursor: "pointer",
            backgroundColor: isPlaying ? "#8b0000" : "#d2691e",
            color: "white",
            border: "none",
            borderRadius: "1rem",
            fontWeight: "bold",
            transition: "transform 0.2s ease, background-color 0.5s ease",
            boxShadow: "0 4px 15px rgba(0,0,0,0.3)",
          }}
          onMouseDown={(e) => (e.currentTarget.style.transform = "scale(0.95)")}
          onMouseUp={(e) => (e.currentTarget.style.transform = "scale(1)")}
        >
          {isPlaying ? "🔕 Silence" : "🔥 Light Fire"}
        </button>
      </div>

      <div
        style={{
          marginTop: "2rem",
          fontSize: "0.9rem",
          opacity: 0.5,
        }}
      >
        A cozy retreat for your mind.
      </div>
    </div>
  );
}

const container = document.getElementById("root");
if (!container) {
  throw new Error("Missing #root element");
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
